var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"people2"},[_c('logistics'),_vm._v(" "),_c('div',{staticClass:"c-t"},[_c('router-link',{attrs:{"to":"/Peoplex"}},[_c('el-button',{attrs:{"type":"success","icon":"el-icon-arrow-left"}},[_vm._v("详情")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-77c9ac73","hasScoped":true,"buble":{"transforms":{}}}!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/people2.vue
// module id = 238
// module chunks = 1